export default "__VITE_ASSET__CKU$TE50__"